var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.5 15h9c.275 0 .5-.225.5-.5V5h-1.5c-.827 0-1.5-.673-1.5-1.5V1H5.5c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15 4v-.086a.496.496 0 00-.146-.353L13 1.707V3.5c0 .275.225.5.5.5H15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fill: "#605E5C",
    d: "M15.56 2.853L13.146.44A1.51 1.51 0 0012.086 0H5.5C4.673 0 4 .673 4 1.5v13c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5V3.914c0-.4-.156-.777-.44-1.06zm-.707.708c.095.094.147.22.147.353V4h-1.5a.501.501 0 01-.5-.5V1.707l1.854 1.854zM14.5 15h-9a.501.501 0 01-.5-.5v-13c0-.275.225-.5.5-.5H12v2.5c0 .827.673 1.5 1.5 1.5H15v9.5c0 .275-.225.5-.5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#038387",
    d: "M1 13h7a1 1 0 001-1V5a1 1 0 00-1-1H1a1 1 0 00-1 1v7a1 1 0 001 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.012 6h.953v5h-.953z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.012 6h2.801v1H3.012zM3.465 8h2.241v.953H3.465z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#038387",
    d: "M10 10v1h2.5a.5.5 0 010 1H10v1h2.5a1.5 1.5 0 000-3H10z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A9BA1",
    d: "M10 6v1h2.5a.5.5 0 010 1H10v1h2.5a1.5 1.5 0 000-3H10z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.fade2de7900b6c7926cc5a231104d060.svg";
export { ForwardRef as ReactComponent };